export default class BreadcrumbsPath {
    public id: string;
    public title: string;
    public relativePath: string;
    public parentBredcrumbsItem: BreadcrumbsPath;

    public latestPageTitle: string;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.relativePath = "";
      this.latestPageTitle = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/breadcrumbsPathEntity.ts